import { AnimatePresence, MotionProps, motion } from 'motion/react';
import * as React from 'react';

const MotionRoot = motion.div;

type Props = MotionProps & {
  isVisible: boolean;
  motionRootContainer?: React.FunctionComponent;
  children?: React.ReactNode;
};

export const AnimatedComponent: React.FC<Props> = ({
  isVisible,
  motionRootContainer,
  children,
  ...rest
}) => {
  const MotionRootContainer = motionRootContainer ?? React.Fragment;
  return (
    <AnimatePresence>
      {isVisible && (
        <MotionRootContainer>
          <MotionRoot {...rest}>{children}</MotionRoot>
        </MotionRootContainer>
      )}
    </AnimatePresence>
  );
};
